import React from 'react';
import { FaWater, FaLeaf, FaFlask, FaPaintBrush } from 'react-icons/fa'; // You can adjust icons as needed

const features = [
  {
    icon: <img src="//kyari.co/cdn/shop/files/Group_12.png?v=1745919556&width=480" alt="Durable Material" />,
    title: 'Durable Material',
    description: 'Built with high-quality plastic for long-lasting use, indoors or outdoors.',
  },
  {
    icon: <img src="//kyari.co/cdn/shop/files/Group_1000009772_1.png?v=1745919555&width=480" alt="Lightweight & Portable" />,
    title: 'Lightweight & Portable',
    description: 'Easy to move around and rearrange to match your space.',
  },
  {
    icon: <img src="//kyari.co/cdn/shop/files/Group_1000009771_1_3c27759c-f637-45e0-b10c-6418404d3999.png?v=1745919555&width=480" alt="Variety of Styles" />,
    title: 'Variety of Styles',
    description: 'Available in multiple colors, sizes, and textures to suit every décor.',
  },
  {
    icon: <img src="//kyari.co/cdn/shop/files/Group_1000010020_1.png?v=1745919555&width=480" alt="Affordable & Eco-Friendly" />,
    title: 'Affordable & Eco-Friendly',
    description: 'Budget-friendly options made from recyclable plastic materials.',
  },
];

const WhyChoose = () => {
  return (
    <div className="py-16 px-4 md:px-20 bg-white text-center">
      <h2 className="text-3xl font-outfit md:text-4xl font-semibold text-green-900 mb-12">
        Why Choose Durapot?
      </h2>
      <div className="grid  grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {features.map((item, index) => (
          <div
            key={index}
            className="p-6 shadow-cardShadow border rounded-2xl hover:shadow-md transition-shadow duration-300"
          >
            <div className="text-green-900 mb-4 flex justify-center">
              {item.icon}
            </div>
            <h3 className="text-lg font-semibold font-outfit text-gray-800 mb-2">
              {item.title}
            </h3>
            <p className="text-sm font-poppins text-gray-600">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChoose;
